document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.site-header');
  const drawer = document.querySelector('.mobile-drawer');
  const toggle = document.querySelector('[data-mobile-toggle]');

  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', drawer.classList.contains('is-open') ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-carousel]').forEach((wrap) => {
    const track = wrap.querySelector('.product-carousel');
    const prev = wrap.querySelector('[data-prev]');
    const next = wrap.querySelector('[data-next]');
    if (!track) return;
    const move = () => Math.max(track.clientWidth * 0.8, 260);
    prev?.addEventListener('click', () => track.scrollBy({ left: -move(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: move(), behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (main) {
          main.src = thumb.dataset.image;
          main.srcset = thumb.dataset.image;
        }
      });
    });
  });

  document.querySelectorAll('[data-qty]').forEach((qty) => {
    const input = qty.querySelector('input');
    qty.querySelector('[data-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    qty.querySelector('[data-plus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
    });
  });
});